import { object, string } from 'yup';

export const validationRules = {
  name: string().required(),
  address: object().required().nullable(),
};

export default object().shape(validationRules);
